// extracted by mini-css-extract-plugin
export var checkbox = "_2f-0";
export var circle = "_2f-3";
export var horizontalContainer = "_2f-7";
export var sm = "_2f-5";
export var switch0 = "_2f-2";
export var switchDisabled = "_2f-8";
export var switchEnabled = "_2f-1";
export var textSwitchContainer = "_2f-9";
export var textSwitchOption = "_2f-a";
export var textSwitchOptionSelected = "_2f-b";
export var verticalContainer = "_2f-6";
export var xs = "_2f-4";